import React from "react";
import { Cartesian3 } from "cesium";
import { Entity, BillboardGraphics } from "resium";
import { useRequest } from "ahooks";

function PortLayer() {
  const { data, loading } = useRequest("/geojson/ports/ru_ports.geojson");
  if (loading) return null;
  const boards = data.features.map((feature, index) => {
    const [lng, lat] = feature.geometry.coordinates;
    const name = feature.properties["name"];
    const enName = feature.properties["en_name"];
    let image = "port.png";
    let scale = 1.0;
    const position = Cartesian3.fromDegrees(lng, lat);
    return (
      <Entity
        key={`billboard-${index}`}
        position={position}
        properties={{  name, enName, model: "port" }}
      >
        <BillboardGraphics
          image={`/navigate/images/${image}`}
          scale={scale}
          rotation={0}
        />
      </Entity>
    );
  });
  return boards;
}

export default PortLayer;
